module.exports = __webpack_public_path__ + "img/00048.ceba7228.webp";